import { jsx } from 'react/jsx-runtime';
import { EGDSBasicVideo } from '../video-basic/index.esm.js';
import { EGDSEmbedVideo } from '../video-embed/index.esm.js';
import { VideoType } from '../types/index.esm.js';
const EGDSVideo = props => {
  const {
    videoType = VideoType.EMBED
  } = props;
  switch (videoType) {
    case VideoType.EMBED:
      return jsx(EGDSEmbedVideo, {
        ...props
      });
    case VideoType.BASIC:
      return jsx(EGDSBasicVideo, {
        ...props
      });
    default:
      return jsx(EGDSEmbedVideo, {
        ...props
      });
  }
};
export { EGDSVideo };